// Photo/PDF upload: photos are downsized in the browser (≈2000px JPEG) so phone pictures upload fast on a truck-stop connection.
import { api } from './api';

const MAX_SIDE = 2000;

async function toJpeg(file: File): Promise<Blob> {
  const bmp = await createImageBitmap(file, { imageOrientation: 'from-image' } as ImageBitmapOptions).catch(() => null);
  if (!bmp) return file;
  const scale = Math.min(1, MAX_SIDE / Math.max(bmp.width, bmp.height));
  const canvas = document.createElement('canvas');
  canvas.width = Math.round(bmp.width * scale);
  canvas.height = Math.round(bmp.height * scale);
  canvas.getContext('2d')!.drawImage(bmp, 0, 0, canvas.width, canvas.height);
  bmp.close();
  return new Promise((res, rej) => canvas.toBlob(b => (b ? res(b) : rej(new Error('encode'))), 'image/jpeg', 0.85));
}

const toBase64 = (b: Blob) => new Promise<string>((res, rej) => {
  const r = new FileReader();
  r.onload = () => res(String(r.result).split(',')[1] ?? '');
  r.onerror = () => rej(r.error);
  r.readAsDataURL(b);
});

export async function uploadFile(file: File, kind: 'receipt' | 'unit_photo' | 'inspection' | 'dvir' | 'payment' | 'other') {
  const isPdf = file.type === 'application/pdf';
  const blob = isPdf ? file : await toJpeg(file);
  const mime = isPdf ? 'application/pdf' : blob.type || 'image/jpeg';
  return api.post<{ id: number; mime: string; size_bytes: number }>('/files', { kind, mime, filename: file.name.slice(0, 200), data_base64: await toBase64(blob) });
}

export const fileUrl = (id: number | null | undefined) => (id ? `/api/files/${id}` : null);
